import React from 'react';
import TreeItem from '@mui/lab/TreeItem';

import { DescriptionsColumnTree } from '../models';
import { DescriptionsTreeItem } from './descriptions-tree-item';
import { TreeItemLabel } from './tree-item-label';

export const ColumnTreeItem: React.FC<{
  column: DescriptionsColumnTree;
}> = ({ column }) => {
  return column.descriptions.length === 1 ? (
    <DescriptionsTreeItem descriptions={column.descriptions} />
  ) : (
    <TreeItem
      nodeId={column.nodeId}
      label={
        <TreeItemLabel
          label={column.summary}
          nodeId={column.nodeId}
          managedDescriptions={column.descriptions}
        />
      }
    >
      <DescriptionsTreeItem descriptions={column.descriptions} />
    </TreeItem>
  );
};
